module.exports = " <div class=\"la-ball-pulse-sync la-sm\" :style=pulseStyles _v-3d77e0b4=\"\"> <div _v-3d77e0b4=\"\"></div> <div _v-3d77e0b4=\"\"></div> <div _v-3d77e0b4=\"\"></div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-3d77e0b4!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/v3-components/Controls/Loader.vue
// module id = 323
// module chunks = 0